define(["require", "exports", "../MinioClient", "../MinioClient", "../ProgressBar", "../Models/PresignedUrlRequestAssetModel", "../Models/Content/Asset", "noty"], function (require, exports, MinioClient_1, MinioClient_2, ProgressBar_1, PresignedUrlRequestAssetModel_1, Asset_1, Noty) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var FileUploadController = (function () {
        function FileUploadController(tenantId, options) {
            if (options === void 0) { options = {
                Type: "asset",
                createApiUrl: "../api/v1/contents",
                minioClientGetPresignedUrl: "../api/v1/contents/getpresignedurl/",
                autoCreateProgressbars: true,
                minioClientDebug: true,
                autoCreateAssetAfterFileUploaded: true
            }; }
            this.minioClient = null;
            this.fileSource_ = undefined;
            this.files_ = undefined;
            this.tenantId = tenantId;
            this.options = options;
            this.setEventListeners();
            this.minioClient.debug = this.options.minioClientDebug;
        }
        Object.defineProperty(FileUploadController.prototype, "fileSource", {
            get: function () { return this.fileSource_ === undefined ? ($('#selector')[0]) : this.fileSource_; },
            set: function (val) { this.fileSource_ = val; },
            enumerable: true,
            configurable: true
        });
        ;
        ;
        Object.defineProperty(FileUploadController.prototype, "files", {
            get: function () { return this.files_ || this.fileSource.files; },
            set: function (val) { this.files_ = val; },
            enumerable: true,
            configurable: true
        });
        ;
        ;
        Object.defineProperty(FileUploadController.prototype, "progressBarParent", {
            get: function () { return $("#progressBarContainer"); },
            enumerable: true,
            configurable: true
        });
        ;
        FileUploadController.prototype.setEventListeners = function () {
            var _this = this;
            this.minioClient = new MinioClient_1.MinioClient(this.options.minioClientGetPresignedUrl);
            this.minioClient.AddEventListener("FileUploaded", function (sender, data) {
                if (_this.options.autoCreateAssetAfterFileUploaded)
                    _this.CreateAsset(sender, data);
            });
            this.minioClient.AddEventListener("FileUploadFailed", function (sender, data) { return _this.FileUploadFailed(sender, data); });
            this.minioClient.AddEventListener("GetPresignedUrlFailed", function (sender, data) { return _this.GetPresignedUrlFailed(sender, data); });
        };
        FileUploadController.prototype.Upload = function () {
            console.log("Upload");
            this.CreateFileUpload();
            if (this.options.autoCreateProgressbars)
                this.CreateProgressBars();
        };
        FileUploadController.prototype.CreateFileUpload = function () {
            var fileUploadArray = {};
            for (var i = 0; i < this.files.length; i++) {
                var file = this.files[i];
                var requestObject = new PresignedUrlRequestAssetModel_1.PresignedUrlRequestAssetModel();
                requestObject.Asset = new Asset_1.Asset();
                requestObject.Asset.Type = this.options.Type;
                requestObject.Asset.TenantId = this.tenantId;
                requestObject.Asset.AssignedLocations = ["all"];
                requestObject.fileName = file.name;
                requestObject.size = file.size;
                var fileUpload = new MinioClient_2.FileUpload(file.name, file);
                fileUpload.requestObject = requestObject;
                fileUploadArray[file.name] = fileUpload;
            }
            this.minioClient.UploadFiles(fileUploadArray);
        };
        FileUploadController.prototype.CreateProgressBars = function () {
            var progressBarArray = {};
            var fileUploadArray = this.minioClient.GetFileUploads();
            var _loop_1 = function (key) {
                var fileUpload = fileUploadArray[key];
                var parent_1 = this_1.progressBarParent;
                var progressBar = new ProgressBar_1.ProgressBar(parent_1, fileUpload.name);
                fileUpload.AddEventListener("FileProgress", function (sender, data) {
                    progressBar.Update(data.progress);
                });
                progressBarArray[fileUpload.name] = progressBar;
            };
            var this_1 = this;
            for (var key in fileUploadArray) {
                _loop_1(key);
            }
        };
        FileUploadController.prototype.CreateAsset = function (sender, data) {
            var fileUpload = data.fileUpload;
            var jsonData = JSON.stringify(fileUpload.ResponseObject);
            var request = $.ajax(this.options.createApiUrl, {
                data: jsonData,
                contentType: 'application/json',
                type: 'POST',
                cache: false,
                async: true
            });
            request.done(function (data) { console.log("Create Asset succeeded"); });
            request.fail(function (data) { console.error("Create Asset failed: " + data); });
        };
        FileUploadController.prototype.FileUploadFailed = function (sender, data) {
            console.error(data.error + " " + data.fileUpload.Name);
            new Noty({
                text: "Die Datei konnte nicht hochgeladen werden. \n                <br/>Fehler: FileUploadFailed\n                <br/>file:" + data.fileUpload.Name + "\n                <br />Probieren Sie es erneut oder kontaktieren Sie den technischen Support",
                type: 'error',
                theme: 'metroui',
                timeout: 6000
            }).show();
        };
        FileUploadController.prototype.GetPresignedUrlFailed = function (sender, data) {
            console.error(data.error);
            new Noty({
                text: "Die Datei konnte nicht in die Datenbank \u00FCbernohmen werden. \n                <br/>Fehler: GetPresignedUrlFailed\n                <br />Probieren Sie es erneut oder kontaktieren Sie den technischen Support",
                type: 'error',
                theme: 'metroui',
                timeout: 6000
            }).show();
        };
        return FileUploadController;
    }());
    exports.FileUploadController = FileUploadController;
    $(function () {
        if ($("#fileUploadUI").length > 0) {
            var fileUploadController = new FileUploadController(window["selectedTenant"]);
            $('#uploadButton').on("click", function () {
                fileUploadController.Upload();
            });
        }
    });
});
//# sourceMappingURL=FileUploadController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/FileUploadController.js
// module id = 107
// module chunks = 0